// apps/client/src/providers/PostHogProvider.tsx
// PostHog analytics provider with PII safety for financial data
// Capture is stopped: every event is dropped (see before_send below)

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { ReactNode } from 'react';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || '';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || '/ingest';
const ENV = process.env.REACT_APP_ENV || 'dev';

// Only initialize if we have a key and not in dev
if (POSTHOG_KEY && ENV !== 'dev') {
  posthog.init(POSTHOG_KEY, {
    // Capture stopped 2026-11-04 on the Founder's decision. Autocapture had recorded
    // commission figures from page text. before_send drops every event, including
    // identify and consent-driven capture. posthog stays initialised because logout
    // and consent code call reset() and opt_in_capturing() on it.
    before_send: () => null,
    // Feature flag requests carry the user ID and person properties, and are not events,
    // so before_send does not stop them.
    advanced_disable_flags: true,
    disable_surveys: true,
    api_host: POSTHOG_HOST,
    ui_host: 'https://eu.posthog.com',
    opt_out_capturing_by_default: true,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_exceptions: false,
    session_recording: {
      maskAllInputs: true,  // PII safety for financial data
      maskTextSelector: '[data-ph-mask]',  // Custom mask selector
    },
    enable_recording_console_log: false,  // Disabled: console logs may contain financial data
    disable_session_recording: true,  // Disabled: session recordings capture unmasked financial data
    respect_dnt: true,  // Australian Privacy Act compliance
    persistence: 'localStorage',
    loaded: (ph) => {
      if (ENV === 'dev' || ENV === 'stage') {
        ph.debug();  // Debug mode in dev/stage only
      }
    },
  });
}

export { posthog };

export function PostHogProviderWrapper({ children }: { children: ReactNode }) {
  if (!POSTHOG_KEY || ENV === 'dev') {
    return <>{children}</>;
  }
  return <PHProvider client={posthog}>{children}</PHProvider>;
}
